/* Nomadia · galerie produit :
   1. filtre par COULEUR seule : en Crème, on voit les photos Crème Classique ET Crème Roulettes
      (les photos sont repérées par leur texte alternatif, ex. « Sac cabine Nomadia – Rose Roulettes ») ;
      une photo sans étiquette de variante reste visible pour toutes ;
   2. clic sur une vignette : amener la photo choisie, que les photos soient côte à côte
      (mobile) ou empilées (ordinateur) — le thème calcule mal la position quand des photos sont masquées ;
   3. le zoom au clic sur la grande image est désactivé (voir aussi layout/theme.liquid).
   Changement de couleur : la galerie revient sur sa première photo DANS le carrousel uniquement,
   la page elle-même ne défile jamais (sinon elle remontait en haut à chaque clic sur une pastille). */
(function(){
  var KEYS = window.NM_KEYS || [];

  /* Couleurs connues, déduites des étiquettes (« Crème Classique » → « Crème ») */
  function couleurs(){
    var out = [];
    KEYS.forEach(function(k){
      var c = k.split(' ')[0];
      if (c && out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }

  /* Couleur choisie : première option du sélecteur de variante */
  function current(){
    var vp = document.querySelector('.product-information variant-picker');
    if (!vp) return null;
    var fs = vp.querySelector('fieldset');
    if (!fs) return null;
    var c = fs.querySelector('input:checked');
    return c ? c.value.trim() : null;
  }

  function thumbOf(img){ return img.closest('.slideshow-controls__thumbnail'); }
  function slideOf(img){ return img.closest('slideshow-slide') || img.closest('.product-media-container'); }

  function apply(){
    var couleur = current();
    var gallery = document.querySelector('.product-information media-gallery');
    if (!couleur || !gallery || !KEYS.length) return;
    var liste = couleurs();
    var firstSlide = null;
    gallery.querySelectorAll('img').forEach(function(img){
      var alt = img.getAttribute('alt') || '';
      /* la photo porte-t-elle une couleur connue ? */
      var etiquetee = liste.some(function(c){ return alt.indexOf(c) > -1; });
      var show = !etiquetee || alt.indexOf(couleur) > -1;
      var th = thumbOf(img);
      var el = th || slideOf(img);
      if (!el) return;
      el.style.display = show ? '' : 'none';
      if (!th) {
        if (show) { el.removeAttribute('hidden'); if (!firstSlide) firstSlide = el; }
        else { el.setAttribute('hidden', ''); }
      }
    });
    if (firstSlide && gallery.dataset.nmKey !== couleur) {
      gallery.dataset.nmKey = couleur;
      /* false : pas de défilement de la page, seulement du carrousel */
      amener(firstSlide, 'auto', false);
    }
  }

  /* —— Amener une photo : défilement horizontal (mobile) ou vertical (ordinateur) —— */
  function defilant(el){
    var p = el.parentElement;
    while (p && p !== document.body) {
      var s = getComputedStyle(p);
      var ox = s.overflowX, oy = s.overflowY;
      if ((ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 4) return { el: p, sens: 'x' };
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 4) return { el: p, sens: 'y' };
      p = p.parentElement;
    }
    return null;
  }

  /* pageOk à false : si aucun carrousel n'est trouvé, on ne touche pas à la page. */
  function amener(cible, comportement, pageOk){
    if (!cible) return;
    var sc = defilant(cible);
    if (sc) {
      var r = cible.getBoundingClientRect(), rs = sc.el.getBoundingClientRect();
      if (sc.sens === 'x') {
        var gauche = sc.el.scrollLeft + (r.left - rs.left);
        try { sc.el.scrollTo({ left: gauche, behavior: comportement }); }
        catch (e) { sc.el.scrollLeft = gauche; }
      } else {
        var haut = sc.el.scrollTop + (r.top - rs.top);
        try { sc.el.scrollTo({ top: haut, behavior: comportement }); }
        catch (e) { sc.el.scrollTop = haut; }
      }
      return;
    }
    if (pageOk === false) return;
    var wrap = document.querySelector('.page-wrapper');
    var page = (wrap && wrap.scrollHeight > wrap.clientHeight) ? wrap : document.scrollingElement;
    var marge = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 70;
    var haut2 = page.scrollTop + cible.getBoundingClientRect().top - marge - 12;
    try { page.scrollTo({ top: haut2, behavior: comportement }); }
    catch (e) { page.scrollTop = haut2; }
  }

  function visibles(gallery){
    return [].slice.call(gallery.querySelectorAll('slideshow-slide')).filter(function(s){
      return !s.hasAttribute('hidden') && s.style.display !== 'none';
    });
  }

  function brancherVignettes(){
    var gallery = document.querySelector('.product-information media-gallery');
    if (!gallery || gallery.dataset.nmThumbs) return;
    gallery.dataset.nmThumbs = '1';
    gallery.addEventListener('click', function(e){
      var th = e.target.closest && e.target.closest('.slideshow-controls__thumbnail');
      if (!th || !gallery.contains(th)) return;
      var liste = [].slice.call(gallery.querySelectorAll('.slideshow-controls__thumbnail')).filter(function(t){
        return t.style.display !== 'none';
      });
      var i = liste.indexOf(th);
      if (i < 0) return;
      setTimeout(function(){ amener(visibles(gallery)[i], 'smooth'); }, 40);
      setTimeout(function(){ amener(visibles(gallery)[i], 'smooth'); }, 300);
    }, true);
  }

  var t = null;
  function later(){ clearTimeout(t); t = setTimeout(function(){ apply(); brancherVignettes(); }, 60); }

  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('variant-picker')) { later(); setTimeout(apply, 450); }
  });

  function watch(){
    var root = document.querySelector('.product-information');
    if (!root || root.dataset.nmWatch) return;
    root.dataset.nmWatch = '1';
    new MutationObserver(function(list){
      for (var i = 0; i < list.length; i++) { if (list[i].type === 'childList') { later(); break; } }
    }).observe(root, { childList: true, subtree: true });
  }

  function boot(){ apply(); brancherVignettes(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function(){ apply(); brancherVignettes(); });
  document.addEventListener('shopify:section:load', boot);
})();
